import React, { createContext, useState, useEffect, useCallback } from "react";
import { getSessionStorage, setSessionStorage } from "../pages/utils/sessionStorageUtils";
import {
  getAllStatuses,
  getAreas,
  getBairros,
  getGroups,
  getTarget,
  getEvaluations
} from "../components/Search/apiCalls";
import moment from "moment";

export const SatisfactionMapContext = createContext();

const dateInCache = getSessionStorage("sm_rangeOccurrences", {
  startDate: new Date(2021, 0, 1),
  endDate: new Date(),
});

const rangeOcurrencesInitialDate = {
  startDate: moment(dateInCache.startDate).toDate(),
  endDate: moment(dateInCache.endDate).toDate(),
};

const SatisfactionMapProvider = ({ children }) => {
  
  const [neighborhood, setNeighborhood] = useState(
    getSessionStorage("sm_neighborhood", { name: "Todos" }) 
  );
  const [area, setArea] = useState(getSessionStorage("sm_area", "Todos")); 
  const [group, setGroup] = useState(getSessionStorage("sm_group", "Todos")); 
  const [stateOccurrence, setStateOccurrence] = useState(
    getSessionStorage("sm_stateOccurrence", "Todos") 
  );
  const [status, setStatus] = useState(getSessionStorage("sm_status", "Todos")); 
  const [complaintTarget, setComplaintTarget] = useState(
    getSessionStorage("sm_complaintTarget", "Todos") 
  );
  const [evaluation, setEvaluation] = useState(
    getSessionStorage("sm_evaluation", "Todos") 
  );
  const [late, setLate] = useState(getSessionStorage("sm_late", "Todos"));
  const [rangeOccurrences, setRangeOccurrences] = useState(rangeOcurrencesInitialDate);

  const [complaintTargetList, setComplaintTargetList] = useState([]);
  const [areasList, setAreasList] = useState([]);
  const [groupsList, setGroupsList] = useState([]);
  const [neighborhoodsList, setNeighborhoodsList] = useState([]);
  const [statusesList, setStatusesList] = useState([]);
  const [evaluationsList, setEvaluationsList] = useState([]);
  const [complaints, setComplaints] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedItem, setSelectedItem] = useState(null);
  const [mapPosition, setMapPosition] = useState([-6.5319859, -49.8526823]);
  const [mapZoom, setMapZoom] = useState(14);

  useEffect(() => { setSessionStorage("sm_neighborhood", neighborhood); }, [neighborhood]);
  useEffect(() => { setSessionStorage("sm_area", area); }, [area]);
  useEffect(() => { setSessionStorage("sm_group", group); }, [group]);
  useEffect(() => { setSessionStorage("sm_stateOccurrence", stateOccurrence); }, [stateOccurrence]);
  useEffect(() => { setSessionStorage("sm_status", status); }, [status]);
  useEffect(() => { setSessionStorage("sm_complaintTarget", complaintTarget); }, [complaintTarget]);
  useEffect(() => { setSessionStorage("sm_evaluation", evaluation); }, [evaluation]);
  useEffect(() => { setSessionStorage("sm_late", late); }, [late]);
  useEffect(() => { setSessionStorage("sm_rangeOccurrences", rangeOccurrences); }, [rangeOccurrences]);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const [statuses, groups, targets, bairros, areas, evaluations] = await Promise.all([
        getAllStatuses(),
        getGroups(),
        getTarget(),
        getBairros(),
        getAreas(),
        getEvaluations()
      ]);
      setStatusesList(statuses);
      setGroupsList(groups);
      setComplaintTargetList(targets.map(t => t.target));
      setNeighborhoodsList(bairros);
      setAreasList(areas);
      setEvaluationsList(evaluations);
    } catch (error) {
      console.error("Falha ao carregar dados dos filtros de satisfação", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const value = {
    fetchData,
    neighborhood, setNeighborhood,
    area, setArea,
    group, setGroup,
    stateOccurrence, setStateOccurrence,
    status, setStatus,
    rangeOccurrences, setRangeOccurrences,
    complaintTarget, setComplaintTarget,
    evaluation, setEvaluation,
    complaintTargetList,
    areasList,
    groupsList,
    neighborhoodsList,
    statusesList,
    evaluationsList,
    late, setLate,
    complaints, setComplaints,
    loading, setLoading,
    selectedItem, setSelectedItem,
    mapPosition, setMapPosition,
    mapZoom, setMapZoom,
  };

  return (
    <SatisfactionMapContext.Provider value={value}>
      {children}
    </SatisfactionMapContext.Provider>
  );
};

export default SatisfactionMapProvider;